/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingOutlined } from '@ant-design/icons';
import { useReviewState } from '@core/configureStore';
import { StarRating } from '@core/models';
import { Card, Rate } from 'antd';
import React, { useMemo } from 'react';

type Props = {};

const AverageRatingWidget = (props: Props) => {
  const { reviewResponse, isLoading: isLoadingReview } = useReviewState();
  const reviewStarRatings: number[] = useMemo(
    () =>
      (reviewResponse.reviews || []).map(
        review => StarRating[review?.starRating.valueOf()] as any
      ) || [],
    [reviewResponse]
  );
  const averageRating = useMemo(() => {
    return reviewStarRatings?.length > 0
      ? reviewStarRatings.reduce((rA: any, rB: any) => rA + rB) / reviewResponse.totalReviewCount
      : 0;
  }, [reviewStarRatings]);
  return (
    <Card>
      <h1>Average rating</h1>
      {isLoadingReview ? (
        <LoadingOutlined />
      ) : (
        <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
          <h1>{parseFloat(averageRating.toFixed(2))}</h1>
          <Rate
            style={{ fontSize: 18 }}
            defaultValue={0}
            allowHalf
            disabled
            value={averageRating}
          />
        </div>
      )}
    </Card>
  );
};

export default AverageRatingWidget;
